const Input = ({ variant, ...rest }) => {
    let classes;
    if (variant === 'outlined') {
        classes =
            'shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light placeholder-gray-700';
    } else if (variant === 'underlined') {
        classes =
            'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer';
    }
    return <input {...rest} className={classes} required />;
};

export default Input;
